import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import * as Sentry from "@sentry/react";

import DashboardLayout from 'src/layouts/dashboard';
import {AuthGuard, ModuleGuard, SupervisorPermissionGuard} from 'src/auth/guard';

import {LoadingScreen} from 'src/components/loading-screen';

import Page500 from "../../pages/500";

// ----------------------------------------------------------------------

// OVERVIEW
const CalendarioPage = lazy(() => import('src/pages/CalendarioPage'));
const BachecaPage = lazy(() => import('src/pages/bacheca/BachecaPage'));
const BollaturaPage = lazy(() => import('src/pages/BollaturaPage'));
const ExpenseReportsPage = lazy(() => import('src/pages/note-spese/ExpenseReportsPage'));
const DocumentsPage = lazy(() => import('src/pages/DocumentsPage'));
const PendingDocumentsPage = lazy(() => import('src/pages/PendingDocumentsPage'));
const AccountPage = lazy(() => import('src/pages/AccountPage'));
const DatiContabiliPage = lazy(() => import('src/pages/DatiContabiliPage'));
const CompanyRequestPage = lazy(() => import('src/pages/approvazione-richieste/CompanyRequestPage'));
const RequestPage = lazy(() => import('src/pages/richieste/RequestPage'));
const YearlyPlanningPage = lazy(() => import('src/pages/pianificazione-ferie/YearlyPlanningPage'));
const GuestPage = lazy(() => import('src/pages/bollatura/GuestPage'));

// ----------------------------------------------------------------------

export const appRoutes = [
  {
    path: '',
    element: (
      <AuthGuard>
        {import.meta.env.VITE_ENV !== 'local' && import.meta.env.VITE_ENV !== 'staging' ? (
          <Sentry.ErrorBoundary fallback={<Page500/>}>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen/>}>
              <Outlet/>
            </Suspense>
          </DashboardLayout>
        </Sentry.ErrorBoundary>
        ) : (
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen/>}>
              <Outlet/>
            </Suspense>
          </DashboardLayout>
        )}
      </AuthGuard>
    ),
    children: [
      {element: <CalendarioPage/>, index: true},
      {path: 'bacheca', element: <ModuleGuard flag="feature_communications"><BachecaPage/></ModuleGuard>},
      {path: 'bollatura', element: <ModuleGuard flag="feature_timesheet"><BollaturaPage/></ModuleGuard>},
      {path: 'note-spese', element: <ExpenseReportsPage/>},
      {path: 'documenti', element: <ModuleGuard flag="feature_documents"><DocumentsPage/></ModuleGuard>},
      {path: 'moduli-da-compilare', element: <ModuleGuard flag="feature_documents"><PendingDocumentsPage/></ModuleGuard>},
      {path: 'profilo', element: <AccountPage/>},
      {path: 'dati-contabili', element: <ModuleGuard flag="feature_payroll_data"><DatiContabiliPage/></ModuleGuard>},
      {
        path: 'approva-richieste',
        element: (
          <SupervisorPermissionGuard permission="requests_view">
            <CompanyRequestPage/>
          </SupervisorPermissionGuard>
        )
      },
      {path: 'richieste', element: <RequestPage/>},
      {path: 'pianificazione-ferie', element: <YearlyPlanningPage/>},
      {path: 'ospiti', element: <GuestPage/>},
      // { path: 'employees/:employee_id', element: <EmployeePage /> },
      // { path: 'timesheet/:year/:month', element: <TimesheetPage /> },
      // { path: 'timesheet/:year/:month/:employee_id', element: <MonthlyTimesheetPage /> },
      // { path: 'documents', element: <DocumentsPage /> },
      // { path: 'timetable', element: <ScadenzarioPage /> },
      // { path: 'note-spese', element: <ExpenseReportsPage /> },
      // { path: 'comunicazioni', element: <ComunicazioniPage /> },
      // { path: 'help-desk', element: <HelpDeskPage /> },
      // { path: 'config', element: <ConfigPage /> },
      // { path: 'account', element: <AccountPage /> },
      // { path: 'requests', element: <RequestsPage /> },
      // { path: 'qr-scan', element: <QrCodePage /> },
    ],
  },
];
